import { atom } from 'recoil';
import { FilterDef } from '../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "amex-reports-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'amex-reports-state-active-filters',
    default: []
});

export const STATE_OUTCOMES_UPLOADING = atom<File | undefined>({
    key: "amex-reports-state-report-uploading",
    default: undefined
});
